import collapsibleFactory from '../common/collapsible';
import collapsibleGroupFactory from '../common/collapsible-group';

// menu.js
const PLUGIN_KEY = 'menu';

/*
 * Manage the behaviour of a menu
 * @param {jQuery} $menu
 */
class Menu {
    constructor($menu) {
        this.$menu = $menu;
        this.$body = $('body');

        // If your theme uses "navPages-list-depth-max" to control behavior, keep this:
        this.hasMaxMenuDisplayDepth = this.$body.find('.navPages-list').hasClass('navPages-list-depth-max');

        // Initialize collapsibles and groups (groups enforce exclusive open)
        this.collapsibles = collapsibleFactory('[data-collapsible]', { $context: this.$menu });
        this.collapsibleGroups = collapsibleGroupFactory($menu);

        this.onMenuClick = this.onMenuClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.$navList = $('.navPages-list.navPages-list-depth-max');
        this.$subMenus = this.$navList.find('.navPages-action');

        this.bindEvents();
    }

    collapseAll() {
        this.collapsibles.forEach(collapsible => collapsible.close());
        this.collapsibleGroups.forEach(group => group.close());
    }

    collapseNeighbors($neighbors) {
        const $collapsibles = collapsibleFactory('[data-collapsible]', { $context: $neighbors });
        $collapsibles.forEach($collapsible => $collapsible.close());
    }

    bindEvents() {
        this.$menu.on('click', this.onMenuClick);
        this.$body.on('click', this.onDocumentClick);
    }

    unbindEvents() {
        this.$menu.off('click', this.onMenuClick);
        this.$body.off('click', this.onDocumentClick);
    }

    // onMenuClick(event) {
    //     // IMPORTANT: Always stop propagation so the body handler
    //     // doesn't see clicks that happen *inside* the menu.
    //     event.stopPropagation();
    //     if (this.hasMaxMenuDisplayDepth) {
    //         const $neighbors = $(event.target).parents('.navPages li').siblings();

    //         this.collapseNeighbors($neighbors);

    //         const $closestAction = $(event.target).closest('.navPages-action');
    //         const $parentSiblings = $closestAction.parent().siblings();
    //         const $parentAction = $closestAction.closest('.navPage-subMenu-horizontal').siblings('.navPages-action');
    //         if (this.$subMenus.hasClass('is-open')) {
    //             this.$navList.addClass('subMenu-is-open');
    //         } else {
    //             this.$navList.removeClass('subMenu-is-open');
    //         }

    //         if ($closestAction.hasClass('is-open')) {
    //             $parentSiblings.addClass('is-hidden');
    //             $parentAction.addClass('is-hidden');
    //         } else {
    //             $parentSiblings.removeClass('is-hidden');
    //             $parentAction.removeClass('is-hidden');
    //         }

    //         const aboutDevice = this.detectDevice();
    //         if (aboutDevice.isMobile == false && $parentSiblings.length < $neighbors.length) {
    //             const $anchor = $(event.target).closest('a');
    //             const target = ($anchor.attr('target') || '').toLowerCase();
    //             const wantsNewTab = target === '_blank'
    //                 || event.ctrlKey || event.metaKey      // Ctrl/Cmd-click
    //                 || event.shiftKey                      // Shift-click (often new window)
    //                 || event.button === 1;                 // Middle-click

    //             if (wantsNewTab) {
    //                 // Open in new tab/window. Add 'noopener' for safety.
    //                 // (You can't set rel on window.open, but you can include 'noopener' as a feature.)
    //                 window.open(href, '_blank', 'noopener');
    //             } else {
    //                 // Force same-tab navigation ignoring any preventDefault elsewhere
    //                 // assign() keeps a history entry (back button works). Use replace() to avoid it.
    //                 window.location.assign(href);
    //             }
    //             return;
    //         }
    //     }

    //     // If a child handler (Collapsible) prevented default to toggle, let it be.
    //     else if (event.isDefaultPrevented && event.isDefaultPrevented()) {
    //         return;
    //     }

    //     // Normalize to anchor (clicks can land on nested <svg>/<i>)
    //     const $anchor = $(event.target).closest('a');
    //     if (!$anchor.length) return;

    //     // DO NOT force navigation here; let the browser handle it.
    //     // Also no neighbor collapsing here—CollapsibleGroup handles exclusivity on open.
    // }
    onMenuClick(event) {
        // Keep the body click handler from seeing inside-menu clicks
        event.stopPropagation();

        // Normalize to the anchor (click may land on <svg>/<i> inside the <a>)
        const $anchor = $(event.target).closest('a');
        if (!$anchor.length) return;

        // (Optional) If you still want to manage neighbor visuals like before:
        if (this.hasMaxMenuDisplayDepth) {
            const $neighbors = $anchor.parents('.navPages li').siblings();
            this.collapseNeighbors($neighbors);

            const $closestAction = $anchor;
            const $parentSiblings = $closestAction.parent().siblings();
            const $parentAction = $closestAction
                .closest('.navPage-subMenu-horizontal')
                .siblings('.navPages-action');

            if (this.$subMenus.hasClass('is-open')) {
                this.$navList.addClass('subMenu-is-open');
            } else {
                this.$navList.removeClass('subMenu-is-open');
            }

            if ($closestAction.hasClass('is-open')) {
                $parentSiblings.addClass('is-hidden');
                $parentAction.addClass('is-hidden');
            } else {
                $parentSiblings.removeClass('is-hidden');
                $parentAction.removeClass('is-hidden');
            }
        }

        const aboutDevice = this.detectDevice();
        const isDesktop = (aboutDevice.isMobile === false) || ($(window).width() > 800);

        // ----- DESKTOP rules -----
        if (isDesktop) {
            // Do NOT navigate if the clicked anchor is the first/root item
            if ($anchor.hasClass('is-root')) {
                // Explicitly block navigation to keep the mega menu openable on desktop
                event.preventDefault();
                return;
            }

            // Otherwise, force navigation (respect modifiers and target)
            const href = $anchor.attr('href');
            if (!href || href === '#' || /^javascript:/i.test(href)) {
                return; // nothing meaningful to navigate to
            }

            const target = ($anchor.attr('target') || '').toLowerCase();
            const wantsNewTab =
                target === '_blank' ||
                event.ctrlKey || event.metaKey || // Ctrl/Cmd-click
                event.shiftKey ||                 // Shift-click (often new window)
                event.button === 1;               // Middle-click

            if (wantsNewTab) {
                window.open(href, '_blank', 'noopener');
            } else {
                // Force same-tab navigation even if someone else prevented default
                window.location.assign(href);
            }
            return; // don't fall through
        }

        // ----- MOBILE rules -----
        // If Collapsible already prevented default to toggle a submenu, do nothing.
        if (event.isDefaultPrevented && event.isDefaultPrevented()) {
            return;
        }

        // Otherwise (likely a leaf link), do nothing here and let the browser navigate normally.
    }
    onDocumentClick(e) {
        // Ignore clicks that are inside the menu (extra safety)
        if ($(e.target).closest(this.$menu).length) {
            return;
        }

        // Desktop-only outside-click to collapse all
        if ($(window).width() > 800) {
            this.collapseAll();
        }
    }
    detectDevice() {
        const isUAHandheld = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isNarrow = window.matchMedia('(max-width: 800px)').matches;
        const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || isCoarsePointer;

        return {
            width: window.innerWidth,
            height: window.innerHeight,
            isMobile: isUAHandheld || isNarrow || isCoarsePointer,
            isTouchDevice,
        };



    }
}
/*
 * Create a new Menu instance
 * @param {string} [selector]
 * @return {Menu}
 */
export default function menuFactory(selector = `[data-${PLUGIN_KEY}]`) {
    const $menu = $(selector).eq(0);
    const instanceKey = `${PLUGIN_KEY}Instance`;
    const cachedMenu = $menu.data(instanceKey);

    if (cachedMenu instanceof Menu) {
        return cachedMenu;
    }

    const menu = new Menu($menu);

    $menu.data(instanceKey, menu);

    return menu;
}